import { BaseService } from '@flint/framework';

export default class GetSubscription extends BaseService {
  constructor() {
    super("FETCHING_USER_DATA", 'GetUserStore', true);
  }

  handleEvent(eventName, email) {
    return this.getClient('vetService').get(`/admin-api/users/${email}`);
  }
}